import React from 'react'
import { CognitoUserPool } from "amazon-cognito-identity-js";

//surveyAppUserPool
const poolData = {
    UserPoolId: "ap-southeast-2_2r64XeNdz",
    ClientId: "6cchhpsdkkb9ps5oh7nf4douhe"
}

export default new CognitoUserPool(poolData);